import PropTypes from 'prop-types';

export const videoDataPropTypes = PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    attachId: PropTypes.string,
    attachExt: PropTypes.string,
});
